module.exports = __webpack_public_path__ + "img/icon_tab_04.ed984414.svg";